import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FAIcon from "../FAIcon/FAIcon";
export const ModalHeaderCloseButton = (props) => (_jsx("button", { className: "close", onClick: () => {
        if (props.closeModal) {
            props.closeModal();
        }
    }, "data-dismiss": props.closeModal ? "" : "modal", "aria-label": "Close modal", title: "Close Modal", children: _jsx("span", { "aria-hidden": "true", children: _jsx(FAIcon, { icon: "times" }) }) }));
const ModalHeader = (props) => {
    var _a;
    return (_jsxs("div", { className: "modal-header " + ((_a = props.className) !== null && _a !== void 0 ? _a : ""), children: [_jsx("h2", { className: "modal-title h4", children: props.title }), _jsx(ModalHeaderCloseButton, { closeModal: props.closeModal })] }));
};
export default ModalHeader;
